import theme from '../../base';

const text = {
  foreground: theme.colors.neutrals.gray700,
};

export default text;
